var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.movies.length >= 1)?_c('div',{staticClass:"rowfilm"},[_c('div',{staticClass:"rowfilm__titleWrapper"},[_c('h2',{staticClass:"rowfilm__title"},[_vm._v(_vm._s(_vm.titleRow))]),_c('router-link',{attrs:{"to":{
        name: 'Genres',
        params: { genres: _vm.titleRow },
        query: { link: _vm.fetchUrl },
      }}},[_vm._v("See All")])],1),_c('div',{staticClass:"rowfilm__posters"},_vm._l((_vm.movies.slice(0, 8)),function(movie){return _c('router-link',{key:movie.id,attrs:{"to":{
        name: 'Details',
        params: { id: movie.id },
        query: { link: _vm.fetchUrl },
      }}},[(movie.poster_path)?_c('img',{staticClass:"rowfilm__poster",class:_vm.classRowFilm,attrs:{"src":_vm.imageBackgroundFilm(movie)}}):_vm._e()])}),1)]):_c('div',{staticClass:"rowfilm__notfound"},[_c('h2',[_vm._v("Your search did not match any Movies 😢")])])}
var staticRenderFns = []

export { render, staticRenderFns }